export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Intro Section',
    headline: 'Welcome to Unique motor garage',
    description: 'No one fix your car like we do. we bring to Unique Motor Garage a deep passion for unique cars, and for providing our customers with levels of personal service and attention. ',
    buttonLabel: 'Back To Top',
    imgStart: false,
    img: require('../../images/fortuner.png').default,
    alt: 'purpal car',
    dark: true,
    primary: true,
    darkText: false,
};

export const homeObjTwo = {
    id: 'discover',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Our Services',
    headline: 'we are providing our services in various aspects',
    description: 'Car Repairing Services , Car Washing ,Car Buy and Sell on Commission , Car Decore Items , Car Insurance etc',
    buttonLabel: 'Back To Top',
    imgStart: true,
    img: require('../../images/car-vectors.jpg').default,
    alt: 'Planet',
    dark: false,
    primary: false,
    darkText: true,
};

export const homeObjThree = {
    id: 'signup',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Contact us',
    headline: 'Contact Details',
    description: ' Contact No : +91 8849961447  or +91 9510732433',
    description1: ' Address : Kothariya main road , near Gokul Restaurant , Rajkot - 360022',
    buttonLabel: 'Back To Top',
    imgStart: false,
    img: require('../../images/rally_car_3.svg').default,
    alt: 'Alien',
    dark: false,
    primary: false,
    darkText: true,
};